/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCurrencyTry = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M3.873 14.895 3 13.105l3.999-2.049V9.292l-3.126 1.603L3 9.105l3.999-2.049L7 1h2l-.001 5.031 5.71-2.925.873 1.789-6.583 3.372v1.764l5.71-2.925.873 1.789-6.583 3.372L9 20.946c2.66-.243 10.049-1.581 10.049-8.946H21c0 8.701-7.613 11-12 11H7l-.001-9.708z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCurrencyTry as CurrencyTry };
